/**
 * @prettier
 */
import DescriptionKeyword from "../../components/keywords/Description"
import { createOnlyOAS32ComponentWrapper } from "../../../fn"

const DescriptionWrapper = createOnlyOAS32ComponentWrapper(DescriptionKeyword)

export default DescriptionWrapper
